import hunt from 'huntjs';

import { siteSettings } from './global';

class Reveal {

    constructor(el) {
        if(siteSettings.reducedMotionPref) {
            el.classList.remove('reveal');
        } else {
            this.el = el;
            this.revealType = 'reveal-clip-from-center';
            this.revealDelay = 0;
            // look for data attributes to override defaults
            let rType = this.el.dataset.revealType;
            if(typeof rType != undefined) this.revealType = rType;
            let rDelay = this.el.dataset.revealDelay;
            if(typeof rDelay != undefined) this.revealDelay = parseInt(rDelay);
            // add hunt to see when element enters viewport
            let _this = this;
            this.hunt = new hunt(this.el, {
                enter: function () {
                    _this.reveal();
                }
            });
        }
    }

    reveal() {
        this.el.onanimationend = (e) => {
            if(e.target == this.el) {
                this.el.classList.add('revealed');
                this.el.classList.remove('revealing');
                this.el.style.animation = 'none';
                this.el.onanimationend = null;
            }
        };
        setTimeout(() => {
            this.el.classList.add('revealing');
            this.el.style.animation = `${this.revealType} 500ms 1 forwards ease-in-out`;
        }, this.revealDelay);
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new Reveal(node);
        }
    });
}